var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{ fill:currentcolor;}.cls-2{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/wallet-minus"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wallet-minus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.94 2.20983L9.53001 7.81983H7.12001C6.72001 7.81983 6.33001 7.84983 5.95001 7.92983L6.95001 5.52983L6.99001 5.43983L7.05001 5.27983C7.08001 5.20983 7.10001 5.14983 7.13001 5.09983C8.29001 2.40983 9.59001 1.56983 11.94 2.20983Z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.73 8.09002L18.71 8.08002C18.11 7.91002 17.5 7.82002 16.88 7.82002H10.62L12.87 2.59002L12.9 2.52002C13.04 2.57002 13.19 2.64002 13.34 2.69002L15.55 3.62002C16.78 4.13002 17.64 4.66002 18.17 5.30002C18.26 5.42002 18.34 5.53002 18.42 5.66002C18.51 5.80002 18.58 5.94002 18.62 6.09002C18.66 6.18002 18.69 6.26002 18.71 6.35002C18.86 6.86002 18.87 7.44002 18.73 8.09002Z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.29 9.51982C17.84 9.38982 17.37 9.31982 16.88 9.31982H7.11999C6.43999 9.31982 5.79999 9.44982 5.19999 9.70982C3.45999 10.4598 2.23999 12.1898 2.23999 14.1998V16.1498C2.23999 16.3898 2.25999 16.6198 2.28999 16.8598C2.50999 20.0398 4.20999 21.7398 7.38999 21.9498C7.61999 21.9798 7.84999 21.9998 8.09999 21.9998H15.9C19.6 21.9998 21.55 20.2398 21.74 16.7398C21.75 16.5498 21.76 16.3498 21.76 16.1498V14.1998C21.76 11.9898 20.29 10.1298 18.29 9.51982ZM14.5 16.7498H9.49999C9.08999 16.7498 8.74999 16.4098 8.74999 15.9998C8.74999 15.5898 9.08999 15.2498 9.49999 15.2498H14.5C14.91 15.2498 15.25 15.5898 15.25 15.9998C15.25 16.4098 14.91 16.7498 14.5 16.7498Z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 32,
    height: 32
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.becd7519b49e154a117dba2abdab43f2.svg";
export { ForwardRef as ReactComponent };